import React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { t } from "i18next"
import { ils, getPaginationButton } from "./ItemsList.styles"

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100]

interface PaginationBarProps {
    currentPage: number
    totalPages: number
    onPrev: () => void
    onNext: () => void
    isFirstPage: boolean
    isLastPage: boolean
    // Page size selector
    pageSize?: number
    pageSizeOptions?: number[]
    onPageSizeChange?: (newSize: number) => void
    totalCount?: number
}

export const PaginationBar: React.FC<PaginationBarProps> = React.memo(({
    currentPage,
    totalPages,
    onPrev,
    onNext,
    isFirstPage,
    isLastPage,
    pageSize,
    pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
    onPageSizeChange,
    totalCount,
}) => {
    if (totalPages <= 1 && !onPageSizeChange) return null

    const start = totalCount != null ? currentPage * (pageSize || 10) + 1 : null
    const end = totalCount != null ? Math.min((currentPage + 1) * (pageSize || 10), totalCount) : null

    return (
        <div style={ils.paginationRow}>
            {/* Page size selector */}
            {onPageSizeChange && pageSize != null && (totalCount ?? 0) > 10 && (
                <div style={ils.pageSizeWrapper}>
                    <span style={ils.pageSizeLabel}>{t("Show")}</span>
                    <select
                        value={pageSize}
                        onChange={(e) => onPageSizeChange(Number(e.target.value))}
                        style={ils.pageSizeSelect}
                    >
                        {pageSizeOptions.map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            {/* Navigation */}
            {totalPages > 1 && (
                <>
                    <button onClick={onPrev} disabled={isFirstPage} style={getPaginationButton(isFirstPage)}>
                        <ChevronLeft size={14} />
                    </button>
                    <span style={ils.paginationText}>
                        {t("Page {{current}} of {{total}}", { current: currentPage + 1, total: totalPages })}
                    </span>
                    <button onClick={onNext} disabled={isLastPage} style={getPaginationButton(isLastPage)}>
                        <ChevronRight size={14} />
                    </button>
                </>
            )}
        </div>
    )
})
